export const LOCATION = 'LOCATION';